import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ThemeProvider } from '@ui/providers/theme-provider';
import { startWebDiagnostics } from '@closet-theory/web-diagnostics';
import { App } from './App';
import './theme.css';
import './styles.css';

// Neither console reported an error anywhere until this was wired: of the
// three apps the telemetry endpoint accepts, production had seen no admin
// events at all and a single stylist one.
// Vite types these as `any`; read them through one narrowed view instead of
// three unchecked reads.
const buildEnv = import.meta.env as Record<string, string | undefined>;

startWebDiagnostics({
  app: 'admin',
  apiBaseUrl: buildEnv.VITE_API_BASE_URL ?? window.location.origin,
  release: buildEnv.VITE_RELEASE ?? 'development',
  appVersion: buildEnv.VITE_APP_VERSION ?? '0.0.0',
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider defaultTheme="light">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
